import { render } from "./UserShow.vue?vue&type=template&id=0aff6df4&scoped=true"
import script from "./UserShow.vue?vue&type=script&lang=js"
export * from "./UserShow.vue?vue&type=script&lang=js"

import "./UserShow.vue?vue&type=style&index=0&id=0aff6df4&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aff6df4"]])

export default __exports__